import { create } from "zustand";
import * as pc from "playcanvas";
import * as THREE from "three";

interface ExplorationState {
  showExplorationPanel: boolean;
  setShowExplorationPanel: (value: boolean) => void;

  currentSplat: string;
  setCurrentSplat: (value: string) => void;

  cameraMode: number;
  setExplorationCameraMode: (mode: number) => void;
  switchExplorationCameraMode: () => void;

  //0 = no transparent version , 1 = disable , 2 = enable
  xRayMode: number;
  enableXRayMode: () => void;
  setXRayMode: (mode: number) => void;
  switchXRayMode: () => void;

  currentLevel: string;
  setCurrentLevel: (level: string) => void;

  currentLevelIndex: number;
  setCurrentLevelIndex: (level: number) => void;

  currentVenue: string;
  setCurrentVenue: (venue: string) => void;

  currentVenueName: string;
  setCurrentVenueName: (venue: string) => void;

  resetPositionRotationEvent: number;
  triggerResetPositionRotationEvent: () => void;

  resetOnlyRotationEvent: number;
  triggerResetOnlyRotationEvent: () => void;

  leaveVenueEvent: number;
  triggerLeaveVenue: () => void;

  clearData: () => void;

  exploratingPosition: THREE.Vector3;
  setExploratingPosition: (vector3: THREE.Vector3) => void;

  positionJoystickData: number[];
  setPositionJoystickData: (value: number[]) => void;
  rotationJoystickData: number[];
  setRotationJoystickData: (value: number[]) => void;

  cameraPosition: pc.Vec3;
  setCameraPosition: (data: pc.Vec3) => void;

  cameraLookingPosition: pc.Vec3;
  setCameraLookingPosition: (data: pc.Vec3) => void;

  cameraAngle: number;
  setCameraAngle: (value: number) => void;

  prevChatType: string;
  setPrevChatType: (value: string) => void;

  isLoading: boolean;
  setLoading: (value: boolean) => void;

  isDisplayUI: boolean;
  setIsDisplayUI: (value: boolean) => void;
}

export const useExplorationStore = create<ExplorationState>()((set, get) => ({
  showExplorationPanel: false,
  setShowExplorationPanel: (value) => set({ showExplorationPanel: value }),
  currentSplat: "",
  setCurrentSplat: (value: string) => set({ currentSplat: value }),
  cameraMode: 0,
  setExplorationCameraMode: (mode: number) => {
    set({ cameraMode: mode });
  },
  switchExplorationCameraMode: () => {
    set((state) => ({ cameraMode: state.cameraMode === 0 ? 1 : 0 }));
  },
  xRayMode: 0,
  enableXRayMode: () => {
    set((state) => ({ xRayMode: state.xRayMode === 0 ? 1 : state.xRayMode }));
  },
  setXRayMode: (mode: number) => {
    set({ xRayMode: mode });
  },
  switchXRayMode: () => {
    set((state) => ({ xRayMode: state.xRayMode === 1 ? 2 : 1 }));
  },
  currentLevel: "",
  setCurrentLevel: (level: string) => {
    set({ currentLevel: level });
  },

  currentLevelIndex: 0,
  setCurrentLevelIndex: (level: number) => {
    set({ currentLevelIndex: level });
  },

  currentVenue: "",
  setCurrentVenue: (venue: string) => {
    set({ currentVenue: venue });
  },

  currentVenueName: "",
  setCurrentVenueName: (name: string) => {
    set({ currentVenueName: name });
  },

  resetPositionRotationEvent: 0,
  triggerResetPositionRotationEvent: () => {
    set({ resetPositionRotationEvent: Date.now() });
  },

  resetOnlyRotationEvent: 0,
  triggerResetOnlyRotationEvent: () => {
    set({ resetOnlyRotationEvent: Date.now() });
  },

  leaveVenueEvent: 0,
  triggerLeaveVenue: () => {
    set({ leaveVenueEvent: Date.now() });
  },

  clearData: () => {
    set({
      currentVenue: "",
      currentLevel: "",
      cameraMode: 0,
    });
  },

  exploratingPosition: new THREE.Vector3(0, 0, 0),
  setExploratingPosition: (vector3: THREE.Vector3) => {
    set({
      exploratingPosition: new THREE.Vector3(vector3.x, vector3.y, vector3.z),
    });
  },

  positionJoystickData: [0, 0],
  setPositionJoystickData: (value: number[]) => {
    set({ positionJoystickData: value });
  },
  rotationJoystickData: [0, 0],
  setRotationJoystickData: (value: number[]) => {
    set({ rotationJoystickData: value });
  },

  cameraPosition: new pc.Vec3(0, 0, 0),
  setCameraPosition: (data: pc.Vec3) => {
    set({ cameraPosition: data });
  },

  cameraLookingPosition: new pc.Vec3(0, 0, 0),
  setCameraLookingPosition: (data: pc.Vec3) => {
    set({ cameraPosition: data });
  },

  cameraAngle: 0,
  setCameraAngle: (value: number) => {
    set({ cameraAngle: value });
  },

  prevChatType: "",
  setPrevChatType: (value: string) => set({ prevChatType: value }),

  isLoading: false,
  setLoading: (value: boolean) => {
    set({ isLoading: value });
  },

  isDisplayUI: false,
  setIsDisplayUI: (value: boolean) => {
    set({ isDisplayUI: value });
  },
}));
